// General
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// Services
import { useUpdateUserLocationMutation } from "../../../../services/data.service";
import { sessionService } from "../../../../services/session.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateGeolocationPermissionPromptDialog,
  updateGeolocationPermissionDeniedDialog,
} from "../../../../redux/store/dialogStore";
// Material UI
import { useMediaQuery } from "@mui/material";
// moment
import moment from "moment";

const GeolocationPermissionMounted = () => {
  // API variables
  const [
    updateUserLocation,
    {
      data: updateUserLocationData,
      error: updateUserLocationErrorData,
      isLoading: updateUserLocationLoading,
      isSuccess: updateUserLocationSuccess,
      isError: updateUserLocationError,
    },
  ] = useUpdateUserLocationMutation();

  // Redux variables
  const isLoggedIn = useSelector((state) => state.public.isLoggedIn);
  const dispatch = useDispatch();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // Router variables
  const location = useLocation();

  // Lifecycle | Mounted
  useEffect(() => {
    if (isMobile) {
      if (location.pathname.includes("payment")) return;

      const locationData = sessionService.getLocationData();

      if (
        !locationData?.lat ||
        !locationData?.lng ||
        !locationData?.lastRequested
      ) {
        checkGpsPermission();
      } else if (
        moment().diff(moment(locationData?.lastRequested).toDate(), "days") > 1
      ) {
        sessionService.deleteLocationData();
        checkGpsPermission();
      }
    }
  }, []);

  // Lifecycle | Check for update | isLoggedIn
  useEffect(() => {
    if (!isLoggedIn) return;

    const locationData = sessionService.getLocationData();
    if (locationData?.lat && locationData?.lng && locationData?.location_data) {
      const locationObj = {
        lat: locationData?.lat,
        lng: locationData?.lng,
        location_data: locationData?.location_data,
        type: "device_gps",
      };
      updateUserLocation(locationObj);
    }
  }, [isLoggedIn]);

  // Utility Functions
  const checkGpsPermission = async () => {
    try {
      const status = await navigator.permissions.query({
        name: "geolocation",
      });

      switch (status.state) {
        case "granted":
          getGpsLocation();
          break;
        case "denied":
          dispatch(updateGeolocationPermissionDeniedDialog(true));
          break;
        case "undetermined":
          break;
        case "prompt":
          dispatch(updateGeolocationPermissionPromptDialog(true));
          break;
        default:
          break;
      }

      // Listen to changes to the permission | Not needed yet
      status.onchange = () => {
        switch (status.state) {
          case "granted":
            break;
          case "denied":
            dispatch(updateGeolocationPermissionPromptDialog(false));
            dispatch(updateGeolocationPermissionDeniedDialog(true));
            break;
          case "undetermined":
            break;
          case "prompt":
            getGpsLocation();
            break;
          default:
            break;
        }
      };
    } catch (error) {}
  };
  const getGpsLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const locationDataObj = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            lastRequested: moment().toDate(),
          };
          sessionService.setLocationData(locationDataObj);

          if (isLoggedIn) {
            const locationObj = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              type: "device_gps",
            };
            updateUserLocation(locationObj);
          }
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              break;
            case error.POSITION_UNAVAILABLE:
              break;
            case error.TIMEOUT:
              break;
            case error.UNKNOWN_ERROR:
              break;
            default:
              break;
          }
        }
      );
    } else {
    }
  };

  return <div id="geolocation-permission-mounted-shadow-component"></div>;
};

export default GeolocationPermissionMounted;
